import {
  format,
  subDays,
  isBefore,
  startOfMonth,
  endOfMonth,
  addMonths,
  differenceInDays,
  sub,
  add,
  endOfWeek,
  startOfWeek,
} from 'date-fns';

import { dateArrayToDate } from './array-date-utils';

export function secondsToTimeString(countdown: number): string {
  const hours = `0${Math.floor(countdown / (60 * 60))}`.slice(-2);

  const minutesDivisor = countdown % (60 * 60);
  const minutes = `0${Math.floor(minutesDivisor / 60)}`.slice(-2);

  const secondsDivisor = minutesDivisor % 60;
  const seconds = `0${Math.ceil(secondsDivisor)}`.slice(-2);

  return `${hours}:${minutes}:${seconds}`;
}

export function addOneDay(date: Date) {
  const tomorrow = new Date(date);
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow;
}

export function addOneDayToToday() {
  return addOneDay(new Date());
}

export const getLastActivityDate = (inactiveDays: number) => {
  const lastActivityDate = subDays(new Date(), inactiveDays);
  return format(lastActivityDate, 'dd/MM/yyyy');
};

export const getExpirationDate = (localDate: number[]) => {
  const date = dateArrayToDate(localDate)!;

  if (!date) {
    return {};
  }
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0); // NOTE: start of the day
  return {
    date: format(date, 'dd/MM/yyyy'),
    isExpired: isBefore(date, today),
  };
};

export const standardStringToDate = (standardStr: string) => {
  const [year, month, day] = standardStr.split('-');
  return new Date(Number(year), Number(month) - 1, Number(day));
};

export const dateToStandardString = (date: Date): string => {
  return format(date, 'yyyy-MM-dd');
};

export {
  addMonths,
  startOfMonth,
  endOfMonth,
  differenceInDays,
  sub,
  add,
  endOfWeek,
  startOfWeek,
};
